import {
	ChartContainer,
	ChartTooltip,
	ChartTooltipContent,
} from "@/components/ui/chart";
import dayjs from "dayjs";
import { Line, LineChart, XAxis } from "recharts";
import type { EntryViewT } from "../../../types/database/entries";
import {
	convertEntriesToChartConfig,
	convertEntriesToChartData,
} from "./utils";

export function GenericChart({
	entries,
	formId,
	disableAnimations = false,
}: {
	entries: EntryViewT[];
	formId: string;
	disableAnimations?: boolean;
}) {
	const chartConfig = convertEntriesToChartConfig(entries, formId);
	const chartData = convertEntriesToChartData(entries, formId);

	console.log(chartData);
	return (
		<ChartContainer config={chartConfig}>
			<LineChart accessibilityLayer data={chartData}>
				<XAxis
					dataKey="date"
					tickLine={false}
					tickMargin={10}
					axisLine={false}
					tickFormatter={(value) => {
						return dayjs(value).format("DD MMM");
					}}
				/>
				<Line
					type="monotone"
					dataKey={Object.keys(chartConfig)[0]}
					strokeWidth={2}
					stroke="hsl(var(--chart-1))"
					isAnimationActive={!disableAnimations}
				/>
				<ChartTooltip
					content={
						<ChartTooltipContent
							hideLabel
							className="p-3 w-[200px]"
							formatter={(value, name, item) => (
								<>
									<div className="mb-2 pb-2 border-b">
										<div className="font-medium text-slate-900 text-sm">
											{item.payload.timing}
										</div>
										<div className="mt-1 text-slate-600 text-xs">
											{dayjs(item.payload.date).format(
												"DD MMM YYYY",
											)}
										</div>
									</div>
									<div className="flex justify-between items-center text-slate-800">
										<span className="font-medium text-sm">
											Value
										</span>
										<div className="bg-indigo-100 ml-2 px-2 py-0.5 rounded-sm font-mono font-medium tabular-nums text-foreground">
											{value}
										</div>
									</div>
								</>
							)}
						/>
					}
					cursor={false}
				/>
			</LineChart>
		</ChartContainer>
	);
}
